import React, { PureComponent } from 'react';
import moment from 'moment';
import { convertFieldFormatToMoment, is24Hrs } from '../../../helpers/DateTimeUtility';
import GfModal from '../../../gfcomponents/GfModal/GfModal';

export interface TimeModalProps {
  value?: string;
  fieldType?: number;
  onClose?: VoidFunc;
  onChanged?: (formatedDate: string) => void;
  dateTimeFormat?: string;
}

export default class TimeModal extends PureComponent<TimeModalProps, TypeMePlease> {
  private is24Hours: boolean;

  constructor(props) {
    super(props);

    this.getDateFormat = this.getDateFormat.bind(this);
    this.pickerClose = this.pickerClose.bind(this);
    this.handleHourChange = this.handleHourChange.bind(this);
    this.handleMinuteChange = this.handleMinuteChange.bind(this);
    this.handleAmPmChange = this.handleAmPmChange.bind(this);
    this.handleDoneButtonClicked = this.handleDoneButtonClicked.bind(this);
    this.handleClearButtonClicked = this.handleClearButtonClicked.bind(this);

    let currentDateTime = null;
    if (this.props.value) {
      currentDateTime = moment(this.props.value, this.getDateFormat());
    } else {
      currentDateTime = moment(new Date());
    }

    this.is24Hours = is24Hrs(this.getDateFormat());

    this.state = {
      selectedDay: currentDateTime.toDate(),
      selectedHour: currentDateTime.format(this.is24Hours ? 'H' : 'h'),
      selectedMinute: currentDateTime.format('m'),
      selectedAmPm: currentDateTime.format('a')
    };
  }

  getDateFormat() {
    return convertFieldFormatToMoment(this.props.dateTimeFormat);
  }

  pickerClose() {
    this.props.onClose();
  }

  handleHourChange(event) {
    this.setState({ selectedHour: event.target.value });
  }

  handleMinuteChange(event) {
    this.setState({ selectedMinute: event.target.value });
  }

  handleAmPmChange(event) {
    this.setState({ selectedAmPm: event.target.value });
  }

  handleDoneButtonClicked() {
    const dateTime = new Date(this.state.selectedDay);
    let amPm = this.state.selectedAmPm;
    let hour = this.state.selectedHour;
    let minute = this.state.selectedMinute;

    if (!this.state.selectedAmPm) {
      amPm = moment(dateTime).format('a');
    }
    if (!this.state.selectedHour) {
      hour = moment(dateTime).format(this.is24Hours ? 'H' : 'h');
    }
    if (!this.state.selectedMinute) {
      minute = moment(dateTime).format('m');
    }

    if (this.is24Hours) {
      dateTime.setHours(hour);
    } else if (amPm === 'am') {
      if (hour === '12') {
        dateTime.setHours(0);
      } else {
        dateTime.setHours(hour);
      }
    } else if (hour === '12') {
      dateTime.setHours(12);
    } else {
      dateTime.setHours(parseInt(hour, 10) + 12);
    }

    dateTime.setMinutes(minute);
    dateTime.setSeconds(0);
    dateTime.setMilliseconds(0);

    const momentValue = moment(dateTime);
    this.props.onChanged(momentValue.format(this.getDateFormat()));
  }

  handleClearButtonClicked() {
    this.props.onChanged('');
  }

  render() {
    return (
      <GfModal
        title="Time"
        className="datetime-modal"
        primaryText="Done"
        secondaryText="Clear"
        onPrimaryClick={this.handleDoneButtonClicked}
        onSecondaryClick={this.handleClearButtonClicked}
        onClose={this.pickerClose}
        semanticUiModalProps={{ size: 'mini', closeOnDimmerClick: true }}
      >
        <div className="ui grid container">
          <div className="three column row">
            <div className="column">
              <select className="ui fluid dropdown" value={this.state.selectedHour} onChange={this.handleHourChange}>
                {this.is24Hours ? <option value="0">0</option> : null}
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                {this.is24Hours ? (
                  <React.Fragment>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                  </React.Fragment>
                ) : null}
              </select>
            </div>
            <div className="column">
              <select className="ui fluid dropdown" value={this.state.selectedMinute} onChange={this.handleMinuteChange}>
                <option value="0">00</option>
                <option value="1">01</option>
                <option value="2">02</option>
                <option value="3">03</option>
                <option value="4">04</option>
                <option value="5">05</option>
                <option value="6">06</option>
                <option value="7">07</option>
                <option value="8">08</option>
                <option value="9">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="43">43</option>
                <option value="44">44</option>
                <option value="45">45</option>
                <option value="46">46</option>
                <option value="47">47</option>
                <option value="48">48</option>
                <option value="49">49</option>
                <option value="50">50</option>
                <option value="51">51</option>
                <option value="52">52</option>
                <option value="53">53</option>
                <option value="54">54</option>
                <option value="55">55</option>
                <option value="56">56</option>
                <option value="57">57</option>
                <option value="58">58</option>
                <option value="59">59</option>
              </select>
            </div>
            {!this.is24Hours ? (
              <div className="column">
                <select className="ui fluid dropdown" value={this.state.selectedAmPm} onChange={this.handleAmPmChange}>
                  <option value="am">am</option>
                  <option value="pm">pm</option>
                </select>
              </div>
            ) : null}
          </div>
        </div>
      </GfModal>
    );
  }
}
